import { createGlobalStyle } from 'styled-components';

export const StyleOverride = createGlobalStyle`
  .check-request .MuiDataGrid-main {
    height: 350px;
  }
`;
